import styled from '@emotion/styled';

import { MediaBP as MQ } from '../../styles/mediaQuery';
export const EpisodeListMainContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  ${MQ.MediaSm} {
    grid-template-columns: repeat(3, 1fr);
  }
  ${MQ.MediaLg} {
    grid-template-columns: repeat(4, 1fr);
  }
  gap: 36px 12px;
  padding-bottom: 200px;
`;
